import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import CircularProgress from "@material-ui/core/CircularProgress"
import { isEmpty, capitalize } from "lodash"
import AddPhotoAlternate from "@material-ui/icons/AddAPhoto"
import { uploadFile, updateVehicle, removeVehicle } from "../../actions/misc"
import { _updateUser } from "../../actions/users"
import { openSnackBar } from "../../actions/snack-bar"
import Cancel from "@material-ui/icons/Cancel"
import pink from "@material-ui/core/colors/pink"
import classNames from "classnames"

const styles = theme => ({
  card: {
    maxWidth: 150,
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    position: "relative",
    "&:hover $removeIconWrapper": {
      opacity: 1
    }
  },
  cardContent: {
    padding: [0, "!important"]
  },
  vehicleName: {
    padding: theme.spacing(1),
    fontSize: "0.9em",
    fontWeight: 600
  },
  addPhotoIcon: {
    color: "#fff",
    width: "1.6em",
    height: "1.6em"
  },
  imageWrapper: {
    width: "100%",
    paddingTop: "100%",
    position: "relative",
    "&:hover $addImageOverlay": {
      opacity: 1
    }
  },
  imageImage: {
    width: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    borderRadius: 0,
    fontSize: "4em",
    fontFamily: '"Oswald"',
    backgroundColor: "#fff"
  },
  image: {
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    borderRadius: 0,
    fontSize: "4em",
    fontFamily: '"Oswald"',
    backgroundColor: "#fff"
  },
  imageUploadOverlay: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: "1",
    backgroundColor: theme.palette.action.active,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    cursor: "wait"
  },
  addImageOverlay: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: "1",
    backgroundColor: theme.palette.action.disabled,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    cursor: "pointer",
    opacity: 0,
    transition: theme.transitions.create("opacity", {
      easing: theme.transitions.easing.easeInOut
    })
  },
  imageLabel: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    cursor: "pointer"
  },
  imageInput: {
    opacity: 0,
    outline: "none"
  },
  iconWrapper: {
    backgroundColor: "#eaeaea",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  removeIconWrapper: {
    top: "5px",
    right: "5px",
    position: "absolute",
    cursor: "pointer",
    opacity: 0,
    zIndex: 3,
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.enteringScreen
    }),
    "&:after": {
      content: "''",
      backgroundColor: pink["A200"],
      height: "20px",
      width: "20px",
      position: "absolute",
      top: "4px",
      right: "4px",
      borderRadius: "50%",
      display: "block",
      zIndex: "0"
    }
  },
  removeIcon: {
    color: "#fff",
    width: "1.2em",
    height: "1.2em",
    position: "relative",
    zIndex: 1
  },
  vehicleIcon: {
    color: "#fff",
    fontSize: "2.2em"
  }
})

class VehicleCard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      uploadingImage: false
    }
  }
  imageChanged = e => {
    const file = e.target.files[0]
    this.setState({ uploadingImage: true })
    this.props
      .dispatch(
        uploadFile(
          file,
          `vehicles/${this.props.vehicle.make.toLowerCase()}/${this.props.vehicle.model.toLowerCase()}`
        )
      )
      .then(image => {
        this.props
          .dispatch(
            updateVehicle(
              {
                photo: JSON.stringify(image),
                make: this.props.vehicle.make,
                model: this.props.vehicle.model,
                year: this.props.vehicle.year
              },
              this.props.vehicle.id,
              this.props.user.id
            )
          )
          .then(res => {
            this.props.dispatch(
              _updateUser({
                id: this.props.user.id,
                vehicles: this.props.user.vehicles.map(v => {
                  if (v.id === this.props.vehicle.id) {
                    v = {
                      ...v,
                      id: res.id,
                      photo: image
                    }
                  }
                  return v
                })
              })
            )
            this.setState({ uploadingImage: false })
            document.getElementById("photo").value = ""
          })
          .catch(err => {
            console.log(err)
            this.props.dispatch(
              openSnackBar({
                message: "There was an error saving photo"
              })
            )
            this.setState({ uploadingImage: false })
            document.getElementById("photo").value = ""
          })
      })
      .catch(err => {
        console.log(err)
        this.setState({ uploadingImage: false })
        document.getElementById("photo").value = ""
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving photo"
          })
        )
      })
  }
  onRemove = () => {
    this.props
      .dispatch(removeVehicle(this.props.vehicle.id, this.props.user.id))
      .then(res => {
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            vehicles: this.props.user.vehicles.filter(
              v => v.id !== this.props.vehicle.id
            )
          })
        )
      })
  }
  renderImage = () => {
    if (!isEmpty(this.props.vehicle.photo)) {
      return (
        <img
          className={this.props.classes.imageImage}
          src={`https://res.cloudinary.com/${
            process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
          }/image/upload/c_thumb,g_center,h_180,w_180,fl_lossy,f_auto/v${
            this.props.vehicle.photo.version
          }/${this.props.vehicle.photo.public_id}.${
            this.props.vehicle.photo.format
          }`}
          alt={`${this.props.vehicle.year} ${this.props.vehicle.make} ${
            this.props.vehicle.model
          }`}
        />
      )
    }
    if (isEmpty(this.props.vehicle.photo)) {
      if (this.props.canControl) {
        return (
          <div className={this.props.classes.iconWrapper}>
            <AddPhotoAlternate className={this.props.classes.addPhotoIcon} />
          </div>
        )
      } else {
        return (
          <div className={this.props.classes.iconWrapper}>
            <i
              className={classNames(
                "icon-vehicle",
                this.props.classes.vehicleIcon
              )}
            />
          </div>
        )
      }
    }
  }
  render() {
    const { classes, vehicle, canControl } = this.props
    return (
      <Card className={classes.card}>
        {canControl && (
          <div className={classes.removeIconWrapper}>
            <Cancel onClick={this.onRemove} className={classes.removeIcon} />
          </div>
        )}
        <CardContent className={classes.cardContent}>
          <div className={classes.imageWrapper}>
            {this.state.uploadingImage && (
              <div className={classes.imageUploadOverlay}>
                <CircularProgress
                  color="inherit"
                  className={classes.imageUploadProgress}
                />
              </div>
            )}
            <label htmlFor="photo" className={classes.imageLabel}>
              {!isEmpty(vehicle.photo) && (
                <div className={classes.addImageOverlay}>
                  <AddPhotoAlternate className={classes.addPhotoIcon} />
                </div>
              )}
              {this.renderImage()}
              {canControl && (
                <input
                  type="file"
                  id="photo"
                  name="photo"
                  className={classes.imageInput}
                  value={this.state.photo}
                  onChange={this.imageChanged}
                />
              )}
            </label>
          </div>
          <Typography
            className={classes.vehicleName}
            gutterBottom
            variant="h6"
            component="h2"
          >
            {vehicle.year} {capitalize(vehicle.make)}{" "}
            {capitalize(vehicle.model)}
          </Typography>
        </CardContent>
      </Card>
    )
  }
}

export default compose(
  connect(),
  withStyles(styles, { withTheme: true })
)(VehicleCard)
